import { render, staticRenderFns } from "./history-tab.vue?vue&type=template&id=752b4dce&scoped=true&"
import script from "./history-tab.vue?vue&type=script&lang=js&"
export * from "./history-tab.vue?vue&type=script&lang=js&"
import style0 from "./history-tab.vue?vue&type=style&index=0&id=752b4dce&lang=scss&scoped=true&"
import style1 from "./history-tab.vue?vue&type=style&index=1&id=752b4dce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752b4dce",
  null
  
)

export default component.exports